const timeAgo = (dateStr) => {
    if (!dateStr) return '-';
    let remaining = Math.floor((Date.now() - new Date(dateStr).getTime()) / 60000);
    const units = [
        ['y', 525960], ['mo', 43830], ['w', 10080], ['d', 1440], ['h', 60], ['m', 1]
    ];
    const parts = [];
    for (const [label, size] of units) {
        const count = Math.floor(remaining / size);
        if (count > 0) {
            parts.push(count + label);
            remaining -= count * size;
        }
        if (parts.length === 2) break;
    }
    return (parts.length ? parts.join(' ') : '0m') + ' ago';
};

export {timeAgo};
